import * as angular from 'angular';

class SortableColumnRequiredValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        elem: JQuery,
        attrs: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpSortableColumnRequiredValidator'] =
            SortableColumnRequiredValidator.validate;
        let hasAlreadyEvaluated = false;

        scope.$watch(
            function () {
                return scope.$eval(attrs['collectionSize']);
            },
            function () {
                hasAlreadyEvaluated && ngModelCtrl.$setDirty();
                hasAlreadyEvaluated = true;
                ngModelCtrl.$validate();
            },
            true
        );
    };

    private static validate(modelValue: any, viewValue: any): boolean {
        if (!modelValue) {
            return true;
        }
        if (!angular.isUndefined(modelValue) && modelValue.length > 0) {
            return true;
        }
        return false;
    }
}

angular
    .module('app')
    .directive(
        'pkpSortableColumnRequiredValidator',
        () => new SortableColumnRequiredValidator()
    );
